import styled from "styled-components";
import { Box, Button, Typography } from "@mui/material";

interface ResponsiveProps {
  $isPhone?: boolean;
  $lang?: string;
  $BgColor?: string;
  $TextColor?: string;
  $width?: string;
}

export const ModalWrapper = styled(Box).withConfig({})<ResponsiveProps>`
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  width: ${({ $isPhone }) => ($isPhone ? "90vw" : "673px")};
  outline: none;
  border-radius: 24px;
  overflow: hidden;
`;

export const ImageContainer = styled(Box)`
  background-color: #f7f4ff;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ContentBox = styled(Box)<ResponsiveProps>`
  display: flex;
  flex-direction: column;
  align-items: ${({ $isPhone }) => ($isPhone ? "center" : "start")};
  padding: ${({ $isPhone }) => ($isPhone ? "16px" : "24px")};
  gap: 10px;
  background: white;
  position: relative; /* Helps with shadow rendering */
  border-bottom: 1px solid #e9e9e7;
  text-align: ${({ $isPhone }) => ($isPhone ? "center" : "start")};

  /* Enhanced shadow - more visible */
  box-shadow: 0 -4px 8px -1px rgba(0, 0, 0, 0.1);
`;

export const Title = styled.span<ResponsiveProps>`
  font-weight: 700;
  font-size: ${({ $isPhone }) => ($isPhone ? "18px" : "24px")};
  color: #331860;
`;

export const Description = styled.span<ResponsiveProps>`
  font-weight: 400;
  font-size: ${({ $isPhone }) => ($isPhone ? "14px" : "16px")};
  color: #4e4d59;
`;

export const ActionContainer = styled.div<ResponsiveProps>`
  background: white;
  justify-content: end;
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
  justify-content: ${({ $isPhone }) => ($isPhone ? "center" : "end")};
  height: ${({ $isPhone }) => ($isPhone ? "80px" : "97px")};
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
  padding: ${({ $isPhone }) => ($isPhone ? "0" : "24px")};
  padding-inline: ${({ $isPhone }) => ($isPhone ? "14px" : "")};
`;

export const StyledButton = styled.button<ResponsiveProps>`
  width: ${({ $width }) => $width};
  height: 49px;
  border-radius: 69px;
  font-size: ${({ $isPhone }) => ($isPhone ? "14px" : "16px")};
  color: ${({ $TextColor }) => $TextColor};
  background-color: ${({ $BgColor }) => $BgColor};
  border: 1px solid #5b3fff;
  cursor: pointer;

  /* 🛑 Remove hover effect */
  &:hover {
    background-color: ${({ $BgColor }) => $BgColor};
    color: ${({ $TextColor }) => $TextColor};
  }
`;
